module.exports = __webpack_public_path__ + "img/Nicolas_Molina.c2298353.jpg";